export const formatPercentageTick = (value: string | number) => `${value}%`;
